import { useLayoutEffect, useEffect } from "react";

// This hook will use useLayoutEffect when running in the browser,
// and useEffect when on the server.
const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
